import ActionTypes from '../constants/ActionTypes';
import standardAction from '../../../utilities/standard-action';

export default function updateLoadingState(loading) {
  return standardAction(ActionTypes.UPDATE_LOADING_STATE, loading);
}
